import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Productlifecycle(props) {
    return (
        <div>
            <Container className="h-100 tekrevol_dark_bg p-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Experts">
                            <h2>Experts In Custom API Development Services And Integration Solutions</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6}>
                        <p>Our range of API development services includes:</p>
                       <ul>
                           <li>API-first product and solution development</li>
                           <li>Custom API development</li>
                           <li>API strategy and prototype</li>
                           <li>Code review and feature testing</li>
                           <li>Web API integration</li>
                       </ul>
                        <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Productlifecycle;